
<template>
    <section class='my-14'>
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head m-4">
                <article-title-tour
                    :options="{
                        tourtitle: currentPage.content.tourtitle.text,
                        titlecolor: 'text-sushi',
                        toursubtitle: currentPage.content.toursubtitle.text,
                        subtitlecolor: 'text-nandor',
                    }"
                ></article-title-tour>
            </div>
            <div class="container-components">
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.firstYear.text,
                            title: currentPage.content.firstTitle.text,
                            pretitle:
                                currentPage.content.firstPretitle.text,
                            content:
                                currentPage.content.firstContent.text,

                            fontSize: {
                                title: 'text-xl 2xl:text-2xl',
                                pretitle: 'text-6xl 2xl:text-6xl',
                            },
                            color: {
                                pretitle: 'text-sushi',
                                title: 'text-dodger_blue',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image1.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image1.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    

                    <TimelineTitle
                        :options="{
                            year: currentPage.content.secondYear.text,
                            pretitle:
                                currentPage.content.secondPretitle.text,
                            title: currentPage.content.secondTitle.text,
                            content:
                                currentPage.content.secondContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image2.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'La transformation du CIH 2017' ),
                    }" class="-top-3 md:top-0 -right-2"/>

                    <TimelineTitle
                        :options="{
                            year: currentPage.content.thirdYear.text,
                            title: currentPage.content.thirdTitle.text,
                            pretitle:
                                currentPage.content.thirdPretitle.text,
                            content:
                                currentPage.content.thirdContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image3.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            color: 'text-black',
                                        },
                                    ],
                                    color: 'text-nandor',
                                    fontSize: 'text-xs',
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.fourthYear.text,
                            title: currentPage.content.fourthTitle.text,
                            pretitle:
                                currentPage.content.fourthPretitle.text,
                            content:
                                currentPage.content.fourthContent.text,

                            fontSize: {
                                pretitle: 'text-base 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image4.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.fifthYear.text,
                            pretitle:
                                currentPage.content.fifthPretitle.text,
                            title: currentPage.content.fifthTitle.text,
                            content:
                                currentPage.content.fifthContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <!-- <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Nouvelle communauté' ),
                    }" class="-top-3 md:top-0 -right-2"/>
 -->

                    <TimelineTitle
                        :options="{
                            year: currentPage.content.sixthYear.text,
                            pretitle:
                                currentPage.content.sixthPretitle.text,
                            title: currentPage.content.sixthTitle.text,
                            content:
                                currentPage.content.sixthContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                                pretitle: 'text-dodger_blue',
                            },
                        }"
                    >
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">

                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Les experts du CIH : épisodes 1 et 2' ),
                    }" class="-top-3 md:top-0 -right-2"/>

                    <TimelineTitle
                        :options="{
                            year: currentPage.content.seventhYear.text,
                            title: currentPage.content.seventhTitle.text,
                            pretitle:
                                currentPage.content.seventhPretitle.text,
                            content:
                                currentPage.content.seventhContent.text,

                            fontSize: {
                                title: 'text-xl 2xl:text-2xl',
                                pretitle: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                pretitle: 'text-sushi',
                                title: 'text-dodger_blue',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image5.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs'
                                        },
                                        {
                                            text: currentPage.images.image5.alt,
                                            position: 'bottom-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.eigthYear.text,
                            title: currentPage.content.eigthTitle.text,
                            pretitle:
                                currentPage.content.eigthPretitle.text,
                            content:
                                currentPage.content.eigthContent.text,

                            fontSize: {
                                pretitle: 'text-3xl 2xl:text-4xl',
                                title: 'text-xl 2xl:text-2xl',
                            },
                            color: {
                                pretitle: 'text-sushi',
                                title: 'text-dodger_blue',
                            },
                        }"
                    >
                        
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.ninthYear.text,
                            title: currentPage.content.ninthTitle.text,
                            pretitle:
                                currentPage.content.ninthPretitle.text,
                            content:
                                currentPage.content.ninthContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <div class="w-1/2 h-auto lg:mx-auto">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image7.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image7.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                    :options="{
                            year: currentPage.content.eleventhYear.text,
                            title: currentPage.content.eleventhTitle.text,
                            pretitle:
                                currentPage.content.eleventhPretitle.text,
                            content:
                                currentPage.content.eleventhContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                    <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image6.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.tenYear.text,
                            pretitle:
                                currentPage.content.tenPretitle.text,
                            title: currentPage.content.tenTitle.text,
                            content:
                                currentPage.content.tenContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image8.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image8.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.image8.alt,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">

                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Parlons compétences' ),
                    }" class="-top-3 md:top-0 -right-2"/>

                    <TimelineTitle
                        :options="{
                            year: currentPage.content.twelveYear.text,
                            title: currentPage.content.twelveTitle.text,
                            pretitle:
                                currentPage.content.twelvePretitle.text,
                            content:
                                currentPage.content.twelveContent.text,

                            fontSize: {
                                title: 'text-xl 2xl:text-2xl',
                                pretitle: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                pretitle: 'text-sushi',
                                title: 'text-dodger_blue',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                            currentPage.slug + '/' +
                            currentPage.images.image9.src,
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.thirdteenYear.text,
                            pretitle:
                                currentPage.content.thirdteenPretitle.text,
                            title: currentPage.content.thirdteenTitle.text,
                            content:
                                currentPage.content.thirdteenContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image10.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image10.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            color: 'text-nandor',
                                            fontSize: 'text-base',
                                        },
                                    ],

                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.fourthteenYear.text,
                                    pretitle:
                                        currentPage.content.fourthteenPretitle.text,
                                    title: currentPage.content.fourthteenTitle.text,
                                    content:
                                        currentPage.content.fourthteenContent.text,


                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image11.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image11.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <div
                        class="
                            container-timeline-title-si-image-with-description
                            relative
                        "
                    >
                        <div
                            class="
                                relative
                                top-0
                                left-0
                                p-7
                                xl:p-3
                                2xl:p-7
                                m-4
                                bg-sushi
                            "
                        >
                            <TimelineTitle
                                :options="{
                                    year: currentPage.content.fifteenYear.text,
                                    title: currentPage.content.fifteenTitle.text,
                                    pretitle:
                                        currentPage.content.fifteenPretitle.text,
                                    content:
                                    currentPage.content.fifteenContent.text,
                                    fontSize: {
                                        title: 'text-2xl',
                                        year: 'text-xl',
                                    },
                                    color: {
                                        year: 'text-selective_orange',
                                        pretitle: 'text-white ',
                                        title: 'text-white',
                                        content: 'text-white',
                                    },
                                }"
                            >
                            </TimelineTitle>
                        </div>
                    </div>
                </div>
                <div class="card break-inside-avoid">




                    <TimelineTitle
                        :options="{
                            year: currentPage.content.sixteenYear.text,
                            title: currentPage.content.sixteenTitle.text,
                            pretitle:
                                currentPage.content.sixteenPretitle.text,
                            content:
                                currentPage.content.sixteenContent.text,

                            fontSize: {
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-2xl lg:text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <div class="relative pt-6">
                                <hotspot-richmedia :options="{
                                    icon: 'diaporama',
                                    collection : getRichmediaByCollection(currentPage, 'Hydrorenewables, le magazine externe du CIH' ),
                                }" class="top-3 right-2"/>
                            </div>

                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image12.src,
                                    descriptions: [
                                        {
                                            text: '',
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />

                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.seventeenYear.text,
                            title: currentPage.content.seventeenTitle.text,
                            pretitle:
                                currentPage.content.seventeenPretitle.text,
                            content:
                                currentPage.content.seventeenContent.text,

                            fontSize: {
                                pretitle: 'text-sm 2xl:text-lg',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-sushi',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image13.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image13.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.image13.alt,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                        :options="{
                            year: currentPage.content.eigteenYear.text,
                            title: currentPage.content.eigteenTitle.text,
                            pretitle:
                                currentPage.content.eigteenPretitle.text,
                            content:
                                currentPage.content.eigteenContent.text,

                            fontSize: {
                                title: 'text-xl 2xl:text-2xl',
                                pretitle: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                pretitle: 'text-sushi',
                                title: 'text-dodger_blue',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                :options="{
                                    image :  'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image14.src,
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
            </div>
        </div>

        <timeline-carousel :options="{
            timeline: currentPage.timeline
        }"/>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10__image-rotation {
    transform: rotate(7deg);
    width: 80%;
    padding: 2rem;
    display: flex;
    justify-content: center;
    margin-left: 2rem;
}

.container-components {
    //column-width: 350px;
    //column-gap: 10px;

    .item {
        position: relative;
        margin: 5px 0;
        padding: 0;
        display: inline-block;
        width: 100%;
        height: auto;
    }
}
</style>
